import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";

export type ErrorType = "NotSupportedError" | "NotFoundError" | "NotAllowedError" | "UnknownError";

export default (errorType: string) => {
  switch (errorType) {
    case "NotSupportedError":
      return autoTranslate("Noise Meter is not supported in this browser. Try using Chrome or Firefox.");
    case "NotFoundError":
      return autoTranslate("No microphone was found on your computer.");
    case "NotAllowedError":
      return autoTranslate("To use Noise Meter, please allow use of the microphone in your browser’s settings.");
    case "UnknownError":
      return autoTranslate("An unknown error occurred.");
  }
};
